export default __webpack_public_path__ + "static/media/Theme20.713126bd.png";